import styled from '@emotion/styled';
import React, { useEffect } from 'react';

import { Form, FormInputText, useForm } from '@modernhealth/vital-components';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FieldValues, UseFormReturn } from 'react-hook-form';

interface Props {
    onChange: (value: number | null) => void;
    validationText?: string;
    placeholderText: string;
    currentNumber?: number;
    onAnswerSubmit: () => void;
}

const StyledForm = styled(Form)({
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: 500,
});

export const NumberInputQuestion: React.FC<Props> = ({
    onChange,
    placeholderText,
    currentNumber,
    onAnswerSubmit,
}) => {
    const schema = Yup.object().shape({
        days: Yup.number().min(0).max(250).required(),
    });

    interface DaysForm {
        days: number;
    }

    const record: Partial<DaysForm> = {
        days: currentNumber,
    };

    const formDefinition = useForm<DaysForm>({
        resolver: yupResolver(schema),
        defaultValues: { ...record },
    });

    useEffect(() => {
        formDefinition.setFocus('days');
        const subscription = formDefinition.watch(({ days }) => {
            onChange(days || null);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [formDefinition, onChange]);

    return (
        <StyledForm
            definition={formDefinition as unknown as UseFormReturn<FieldValues>}
            onSubmit={onAnswerSubmit}
        >
            <FormInputText
                name="days"
                type="number"
                placeholder={placeholderText}
                labelledBy="Number of days"
                trim
            />
        </StyledForm>
    );
};
